// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/work-optimization/DuplicateWorkCard.jsx

import React from "react";

export default function DuplicateWorkCard({ duplicate }) {
  const safeDuplicate = duplicate && typeof duplicate === "object" ? duplicate : null;
  if (!safeDuplicate) return null;

  const taskIds = Array.isArray(safeDuplicate.task_ids) ? safeDuplicate.task_ids : [];

  return (
    <section className="wo-card wo-duplicate-card" aria-label="Duplicate work detection">
      <div className="wo-card-header">
        <div>
          <span>Duplicate Work</span>
          <h3>{safeDuplicate.rule_id || "Potential duplicate effort"}</h3>
          <p>{taskIds.length} task{taskIds.length === 1 ? "" : "s"} may resolve the same underlying issue.</p>
        </div>
      </div>
      <ul className="wo-reasons">
        {(safeDuplicate.why || []).slice(0, 3).map((reason, index) => <li key={`duplicate-reason-${index}`}>{reason}</li>)}
      </ul>
    </section>
  );
}
